/**
 * WIR Euro.
 */
export var CHE = {
  code: 'CHE',
  base: 10,
  exponent: 2
};